import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "src/app/services/app-config.service";
import { JobPlanAPIServiceConstant, JobPlanServiceConstant } from "../constants/job-plan.constant";

@Injectable({
    providedIn: 'root'
})

export class JobPlanSearchService {

    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    apiUrl = AppConfig.settings.apiUrl;

    constructor(private http: HttpClient) { }


    generateQuery(params: any) {
        let p = []; let newParam = '';
        if (params) {
            for (let k in params) {
                let str = k + '=' + params[k]; if (params[k] !== undefined) p.push(str)
            }
            newParam = p.join('&');
        }
        return newParam;
    }
    getJobPlanSearchDetails(data: any) {
        return this.http.post<any>(this.apiUrl + 'JobPlan/GetJobPlanSearch', data, this.httpOptions);
    }

    getJobPlanViewSTeps(data: any) {
        return this.http.get<any>(this.apiUrl + 'JobPlan/ViewSteps?JobPlanNumber=' + data, this.httpOptions)
    }

    getJobPlanPartsSTeps(data: any) {
        return this.http.get<any>(this.apiUrl + 'JobPlan/ViewParts?JobPlanNumber=' + data, this.httpOptions)
    }

    createNewJobplan(payload: any) {
        return this.http.post<any>(this.apiUrl + 'JobPlan/CreateJobPlan?crid=' + payload.crid, {}, this.httpOptions);
    }

    copyJobplan(body:any) { 
        return this.http.post<any>(this.apiUrl + `JobPlan/CopyJobPlan`, body, this.httpOptions);
    }

    upadteJobplan(body:any) {
        return this.http.post<any>(this.apiUrl + `JobPlan/UpdateJobPlans`, body, this.httpOptions);
    }
    getLabourData(changeRequestId: number) {
        let obj = {
            "ChangeRequestId": changeRequestId,
            "MWONumber": '',// null, 
            "EquipTagNumber": "",
            "MWOProblemDescription": "",
            "JobPlanNumber": "",
            "Craft": "",
            "OperationSequence": -1,
            "Description": "",
            "Duration": -1,
            "CrewSize": -1,
            "ICY_N": "",
            "PercentageOverlap": -1,
            "FileName": "",
            "URL": "",
            "FiledDescription": "",
            "JBCD": "",
            // "OriginalJobPlanNumber": ""
        }

        let params = this.generateQuery(obj);

        return this.http.get<any>(`${this.apiUrl + JobPlanAPIServiceConstant.JOBPLANLABOURDETAILSRESPONSE + (params ? '?' + params : '')}`, this.httpOptions);
    }

    getPartsData(changeRequestId: number) {
        let data = {
            ChangeRequestId: changeRequestId,

            // "changeRequestId": 1149,
            "mwoNumber": 0,
            "equipTagNumber": "",
            "mwoProblemDescription": "",
            "jobPlanNumber": "",
            "itemNumber": 0,
            "itemDescription": "",
            "quantity": 0,
            "operationSequence": 0
        }
        let query = this.generateQuery(data)
        return this.http.get<any>(this.apiUrl + JobPlanAPIServiceConstant.GETJOBPLANPARTSGRID + (query ? '?' + query : ''), this.httpOptions);
    }

    findAndReplaceJobPlanNumber(body: any) {

        let params = this.generateQuery(body);
        return this.http.post<any>(this.apiUrl + JobPlanAPIServiceConstant.FINDANDREPLACEJOBPLANNUMBER + (params ? '?' + params : ''), body, this.httpOptions);
    }

    GetItemSearch(skip: number, pageSize: number = 5,branch : string, searchText: string) {
        let params = [];
        if (pageSize > 0) {
            params.push(`skip=${skip}&pageSize=${pageSize}&branch=${branch}`);
        }
        if (searchText) {
            params.push(`searchText=${searchText}`);
        }

        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.get<any>(this.apiUrl + JobPlanAPIServiceConstant.GETITEMSEARCH + url, this.httpOptions);
    }

    getJobPlanData(skip: number, pageSize: number = 5, searchText: string) {
        let params = [];
        if (pageSize > 0) {
            params.push(`skip=${skip}&pageSize=${pageSize}`);
        }
        if (searchText) {
            params.push(`searchText=${searchText}`);
        }

        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.get(this.apiUrl + JobPlanAPIServiceConstant.JOBPLAN + url, this.httpOptions);
    }

    GetTaskDetails(skip: number, pageSize: number = 5, searchText: string) {
        let obj = {
            skip: skip,
            pageSize: pageSize,
            searchText: searchText || undefined
        }

        let url = this.generateQuery(obj);
        return this.http.get(` ${this.apiUrl + JobPlanAPIServiceConstant.GETTASKDETAILS + (url ? '?' + url : '')}`, this.httpOptions);

    }
    ClearJobPlanLabour(data: any) {
        let parameters = this.generateQuery(data);
        return this.http.post(` ${this.apiUrl + JobPlanAPIServiceConstant.CLEARJOBPLANLABOUR + (parameters ? '?' + parameters : '')}`, {}, this.httpOptions);

    }

    ImportJobPlanBuildLabour(CRID: number, data: any) {
        return this.http.post(` ${this.apiUrl + JobPlanAPIServiceConstant.IMPORTJOBPLANBUILDLABOUR + '?CRID=' + CRID}`, data, this.httpOptions);
    }
    ImportJobPlanBuildParts(CRID: number, data: any) {
        return this.http.post(` ${this.apiUrl + JobPlanAPIServiceConstant.IMPORTJOBPLANBUILDPARTS + '?CRID=' + CRID}`, data, this.httpOptions);
    }
    ValidateAndSaveToCr(data: any) {
        return this.http.post(` ${this.apiUrl + JobPlanAPIServiceConstant.SAVEADDTOCR}`, data, this.httpOptions);
    }
    
    deleteLabour( data: any) {
        return this.http.post(` ${this.apiUrl + JobPlanAPIServiceConstant.DELETELABOUR }`, data, this.httpOptions);
    }
    
    deletePart( data: any) {
        return this.http.post(` ${this.apiUrl + JobPlanAPIServiceConstant.DELETEPART }`, data, this.httpOptions);
    }

  GetOnChangeItemSearch(branch: string, searchText: string) {
    let params = [];
    if (branch) {
      params.push(`branch=${branch}`);
    }
    if (searchText) {
      params.push(`searchText=${searchText}`);
    }

    let url = params.length > 0 ? `?${params.join('&')}` : "";
    return this.http.get<any>(this.apiUrl + JobPlanAPIServiceConstant.GETONCHANGEITEMSEARCH + url, this.httpOptions);
  }
}
